<template>
  <!--  动态下拉选组件-->
  <div>

    <el-dialog
      title="编辑"
      :visible.sync="editdata_selects"
      width="30%"
      append-to-body
      v-if="editdata_selects"
    >

      <div v-for="(item,index) in selectInfo" style="display: flex;justify-content: space-between;padding:10px;border-bottom:solid 1px #ccc">

        <div style="font-size: 16px;font-weight: 600">{{ item.label }}</div>
        <div class="btn-error" @click="delselect(item._id)">删除</div>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editdata_selects = false">关 闭</el-button>
  </span>
    </el-dialog>

    <el-select :disabled="disabled" :style="{width: '100%'}" v-model="select_value" clearable @focus="get_select_data()"
               @change="select_class_v2($event)">
      <el-option v-for="(item,index) in selectInfo" :key="index" :label="item.label" :value="item.value"></el-option>
      <el-option value="添加" style="text-align: center"><i class="el-icon-plus"> </i></el-option>
      <el-option value="删除" style="text-align: center"><i class="el-icon-minus"> </i></el-option>
    </el-select>
  </div>

</template>
<script>
import u from "../../../assets/js/util";

export default {
  name: "selectdata",
  props: ["keyname", "disabled", "values"],
  model: {
    prop: 'select_value',
    event: 'parent-event'
  },
  data() {
    return {
      space: "",
      selectInfo: [],
      select_desc: "",
      select_value: "",
      editdata_selects: false
    }
  },
  mounted() {

    setTimeout(() => {

      if (this.values) {
        setTimeout(() => {
          var e = this.values
          this.selectInfo.push({label: e.label, value: e.value})
          this.select_desc = e.label
          this.select_value = e.value
          this.$forceUpdate()
        }, 100)

      }
    })
  },
  methods: {

    setvalue(e) {
      this.selectInfo.push({label: e.label, value: e.value})
      this.select_desc = e.label
      this.select_value = e.value
    },
    async delselect(_id) {

      var list = await u.post("comprehensive", "del_select_list", {
        where: {_id: _id},
        data: {is_delete: 1},
        table: this.keyname + "_select"
      })
      this.get_select_data()


    },
    async get_select_data() {

      if (!this.keyname) {

        u.error("标识不能空")
        return
      }
      this.selectInfo = []
      var info = await u.get_no("comprehensive", "data_get", {
        "table": this.keyname + "_select",
        where: {is_delete: 0}
      })
      if (info !== false) {
        info[0].forEach((item) => {
          this.selectInfo.push({label: item.label, value: item.value, _id: item._id})
        })
      }

      this.$forceUpdate()
    }
    ,
    select_class_v2(e) {
      var _this = this
      console.log(e)

      if (!this.keyname) {

        u.error("标识不能空")
        return
      }
      _this.select_value = ""
      _this.select_desc = ""
      if (e === "添加") {
        this.$prompt('请输入内容', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async (res) => {

          var label = res.value
          if (label) {
            var values = new Date().getTime() + Math.random().toString().substring(2, 8)
            await u.post("comprehensive", "data_edit", {
              "table": this.keyname + "_select",
              data: {value: values, label: label},
            })
            _this.selectInfo.push({label: label, value: values})
            setTimeout(() => {
              _this.select_desc = label
              _this.select_value = values
              _this.$emit("select", {value: _this.select_value, label: _this.select_desc})
              _this.$forceUpdate()
            })

          }
        }).catch(() => {

        });
      }
      if (e === "删除") {
        _this.editdata_selects = true

      } else {
        var is_select = false
        for (var selectInfoKey in this.selectInfo) {

          if (this.selectInfo[selectInfoKey].value == e) {
            is_select = true
            _this.select_value = e
            _this.select_desc = _this.selectInfo[selectInfoKey].label
          }
        }
        if (is_select == false) {
          _this.select_value = ""
          _this.select_desc = ""
        }
        this.$emit("select", {value: _this.select_value, label: _this.select_desc})
      }


    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/selectdata.vue